import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { ListProvider } from '../../providers/list/list';
import { Events } from 'ionic-angular';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { AppState } from '../../config/state';
import { LoginProvider } from '../../providers/login/login';
import { SoundsProvider } from '../../providers/sounds/sounds';
/**
 * Generated class for the CoInterestedPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-interested-popover',
  templateUrl: 'co-interested-popover.html'
})
export class CoInterestedPopoverComponent {
  event: any;
  previousCard: any;

  constructor(private navParams: NavParams, public toast: ToastAlertsProvider, public viewCtrl: ViewController, private listProvider: ListProvider, private events: Events, private timeout : TimeoutFunctionsProvider, private state: AppState, private loginProvider: LoginProvider, private sounds : SoundsProvider) {
    this.event = this.navParams.data.event;
    this.previousCard = this.navParams.data.previousCard;
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  addEventToList(patron?) {
    if (!patron && !this.state.patron) {
      this.loginProvider.requireLogin(this.addEventToList.bind(this));
      return;
    }
    this.event.interested = true;
    this.listProvider.addToList('events', this.event).then((res) => {
      if (res.success) {
        this.triggerToast('event', '', 'success');
        this.events.publish('interestedEventAdded', this.event);
        this.viewCtrl.dismiss().catch(err=>{});
      } else {
        if (res.errorMsg && res.errorMsg.length > 0) {
          this.triggerToast('', res.errorMsg,'warning');
        } else {
          this.triggerToast('', 'Sorry, an error occurred', 'warning');
        }
      }
    });
  }

  removeEventFromList() {
    let listToRemove = [this.event.eventId];
    this.listProvider.removeFromList(listToRemove, 'events').then((res) => {
      if (res.success) {
        this.events.publish('interestedEventRemoved', this.event);
        this.triggerToast('', 'Successfully removed event from your events list!','success');
        this.viewCtrl.dismiss().catch(err=>{});
      } else {
        this.triggerToast('', res.errorMsg,'warning');
      }
    });
  }

  triggerToast(flag: string, msg?: string, msgType?) {
    let message: string;

    if (!msg) {
      switch (flag) {
        case 'calendar':
          message = 'You have added this event to your calendar!';
          break;
        case 'remind':
          message = 'You will be reminded of this event!';
          break;
        case 'event':
          message = 'You have added this event to your events list!';
          break;
        default:
          message = 'Success!';
          break;
      }
    } else {
      message = msg;
    }
    this.toast.triggerToast(message, '', msgType);
  }
}



// WEBPACK FOOTER //
// ./src/components/co-interested-popover/co-interested-popover.ts